( function( app ) {
  const COMPONENT = {
    init: function() {
      const navigation = document.querySelector( '.navigation-one' );
      const mobileCtas = navigation?.querySelector( '.navigation-one__mobile-ctas' );

      const updateMobileCtaClearance = () => {
        if ( !navigation ) return;

        if ( window.innerWidth >= 1024 || !mobileCtas?.children.length ) {
          navigation.style.setProperty( '--navigationDropdownCtaOffset', '0px' );
          return;
        }

        const ctaHeight = mobileCtas.getBoundingClientRect().height;
        navigation.style.setProperty(
            '--navigationDropdownCtaOffset',
          ctaHeight > 0 ? `${ctaHeight + 32}px` : '0px',
        );
      };

      const updateAfterToggle = () => {
        window.requestAnimationFrame( () => {
          window.requestAnimationFrame( updateMobileCtaClearance );
        } );
      };

      updateMobileCtaClearance();
      window.addEventListener( 'resize', updateMobileCtaClearance );
      $( '.navbar-toggle, .primary-menu-item__link' ).on( 'toggleAfter', updateAfterToggle );

      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-one .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-one', COMPONENT );
} )( app );
